var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          class: { "mobile-custom-box": _vm.isMobile },
          attrs: {
            title: _vm.paramsData.id !== "" ? _vm.$t("modify") : _vm.$t("add"),
            visible: _vm.dialogShow
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            },
            close: function($event) {
              return _vm.clearData(true)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              class: { "mobile-form": _vm.isMobile },
              attrs: {
                "label-position": "left",
                rules: _vm.rules,
                model: _vm.paramsData,
                "label-width": "180px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "is_prod", label: _vm.$t("selectEnvironment") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "flex-1",
                      attrs: {
                        filterable: "",
                        placeholder: _vm.$t("pleaseChoose")
                      },
                      model: {
                        value: _vm.paramsData.is_prod,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "is_prod", $$v)
                        },
                        expression: "paramsData.is_prod"
                      }
                    },
                    _vm._l(_vm.severlist, function(item) {
                      return _c("el-option", {
                        key: item.label,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: {
                    prop: "open_server_recharge_num",
                    label: _vm.$t("rechargePeopleNum")
                  }
                },
                [
                  _c("el-input", {
                    staticClass: "flex-1",
                    attrs: {
                      placeholder: _vm.$t("pleaseInputRechargePeopleNum")
                    },
                    model: {
                      value: _vm.paramsData.open_server_recharge_num,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.paramsData,
                          "open_server_recharge_num",
                          $$v
                        )
                      },
                      expression: "paramsData.open_server_recharge_num"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "is_active", label: _vm.$t("isEnabled") }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.paramsData.is_active,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "is_active", $$v)
                        },
                        expression: "paramsData.is_active"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: "1", border: "" } }, [
                        _vm._v(_vm._s(_vm.$t("enabled")))
                      ]),
                      _c("el-radio", { attrs: { label: "0", border: "" } }, [
                        _vm._v(_vm._s(_vm.$t("disabled")))
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: {
                    prop: "date_max_openserver_num",
                    label: _vm.$t("pleaseInputDailyMaxOpenServerCount")
                  }
                },
                [
                  _c("el-input", {
                    staticClass: "flex-1",
                    attrs: { placeholder: _vm.$t("dailyMaxOpenServerCount") },
                    model: {
                      value: _vm.paramsData.date_max_openserver_num,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "date_max_openserver_num", $$v)
                      },
                      expression: "paramsData.date_max_openserver_num"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: {
                    prop: "open_server_register_num",
                    label: _vm.$t("registerCount")
                  }
                },
                [
                  _c("el-input", {
                    staticClass: "flex-1",
                    attrs: { placeholder: _vm.$t("pleaseInputRegisterCount") },
                    model: {
                      value: _vm.paramsData.open_server_register_num,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.paramsData,
                          "open_server_register_num",
                          $$v
                        )
                      },
                      expression: "paramsData.open_server_register_num"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: {
                    prop: "force_start_server_days",
                    label: _vm.$t("forceOpenServerDays")
                  }
                },
                [
                  _c("el-input", {
                    staticClass: "flex-1",
                    attrs: { placeholder: _vm.$t("forceOpenServerDays") },
                    model: {
                      value: _vm.paramsData.force_start_server_days,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "force_start_server_days", $$v)
                      },
                      expression: "paramsData.force_start_server_days"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-row",
                { staticStyle: { width: "100%", "margin-bottom": "0" } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem",
                      attrs: { prop: "main_content" }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.addTimeRange }
                        },
                        [_vm._v(_vm._s(_vm.$t("addOpenServerTimeRange")))]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._l(_vm.paramsData.not_open_hour_duration_list, function(
                timeRange,
                index
              ) {
                return _c(
                  "div",
                  { key: index, staticClass: "time-range-item" },
                  [
                    _c(
                      "div",
                      { staticClass: "time-range-wrapper" },
                      [
                        _c("el-time-picker", {
                          class: { "time-picker-flex": true },
                          attrs: {
                            format: "HH",
                            "value-format": "HH",
                            "is-range": "",
                            "range-separator": _vm.$t("range"),
                            "start-placeholder": _vm.$t("startTime"),
                            "end-placeholder": _vm.$t("endTime"),
                            placeholder: _vm.$t("selectTimeRange")
                          },
                          model: {
                            value:
                              _vm.paramsData.not_open_hour_duration_list[index],
                            callback: function($$v) {
                              _vm.$set(
                                _vm.paramsData.not_open_hour_duration_list,
                                index,
                                $$v
                              )
                            },
                            expression:
                              "paramsData.not_open_hour_duration_list[index]"
                          }
                        }),
                        _vm.paramsData.not_open_hour_duration_list.length > 1
                          ? _c("el-button", {
                              staticClass: "delete-time-btn",
                              attrs: {
                                size: "mini",
                                type: "danger",
                                circle: "",
                                icon: "el-icon-delete"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.removeTimeRange(index)
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              }),
              _c(
                "el-row",
                {
                  staticStyle: {
                    width: "100%",
                    "margin-top": "20px",
                    "margin-bottom": "0"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem",
                      attrs: { prop: "main_content" }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.addContent }
                        },
                        [_vm._v(_vm._s(_vm.$t("addAnnouncement")))]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._l(_vm.paramsData.main_content, function(domain, index) {
                return _c(
                  "div",
                  { key: index + "k", staticClass: "main_contentClass" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "lodingItem-operationFrame flex",
                        staticStyle: { "margin-bottom": "20px" }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass:
                              "lodingItem contentValitem lodingItemt",
                            attrs: {
                              prop: "main_content." + index + ".title",
                              rules: _vm.rules.title,
                              label: _vm.$t("title"),
                              "label-width": "60px"
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "operationFrame-entity",
                              attrs: {
                                clearable: "",
                                placeholder: _vm.$t("pleaseInputTitle")
                              },
                              model: {
                                value: domain.title,
                                callback: function($$v) {
                                  _vm.$set(domain, "title", $$v)
                                },
                                expression: "domain.title"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass:
                              "lodingItem contentValitem lodingItemt",
                            attrs: {
                              prop: "main_content." + index + ".language",
                              rules: _vm.rules.language,
                              label: _vm.$t("language"),
                              "label-width": "60px"
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "flex-1",
                                attrs: {
                                  clearable: "",
                                  filterable: "",
                                  placeholder: _vm.$t("pleaseChoose")
                                },
                                model: {
                                  value: domain.language,
                                  callback: function($$v) {
                                    _vm.$set(domain, "language", $$v)
                                  },
                                  expression: "domain.language "
                                }
                              },
                              _vm._l(_vm.langList, function(item) {
                                return _c("el-option", {
                                  key: item.label,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c("el-button", {
                          staticStyle: { margin: "0 0 20px 10px" },
                          attrs: {
                            size: "mini",
                            type: "danger",
                            circle: "",
                            icon: "el-icon-delete"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.removeContent(domain)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "flex lodingItem-title first_box",
                        staticStyle: {
                          "margin-bottom": "20px",
                          width: "100%",
                          "align-items": "center"
                        }
                      },
                      [
                        _vm._v(_vm._s(_vm.$t("content")) + ": "),
                        _c(
                          "div",
                          {
                            staticClass: "flex",
                            staticStyle: { "padding-left": "20px" }
                          },
                          _vm._l(_vm.tagList, function(items, indexs) {
                            return _c(
                              "div",
                              {
                                key: indexs,
                                staticClass: "addtag",
                                on: {
                                  click: function($event) {
                                    return _vm.addtag(items.content, index)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(items.name))]
                            )
                          }),
                          0
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          prop: "main_content." + index + ".content",
                          rules: _vm.rules.content
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            autosize: { minRows: 2, maxRows: 12 },
                            placeholder: _vm.$t("pleaseInputContent")
                          },
                          model: {
                            value: domain.content,
                            callback: function($$v) {
                              _vm.$set(domain, "content", $$v)
                            },
                            expression: "domain.content "
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              })
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { round: "" },
                  on: {
                    click: function($event) {
                      _vm.dialogShow = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.reqLoading,
                    round: ""
                  },
                  on: { click: _vm.dataFormSubmit }
                },
                [_vm._v(_vm._s(_vm.$t("submit")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }